import { BOT_MODE, MESSAGE_SENDER, MESSAGE_TYPE, SCREEN_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { ENGT_CHAT } from 'js/bot.model';
import { appendToChat, storeBotResponseInLs } from 'js/conversation';
import EngtSocket from 'js/socket';
import { readOutMessage } from 'js/speech.js';

import { playVoiceFromAzure } from '../js/voiceBot';
import { LOGGER, readFromLs, writeToLs } from './helpers';

let engtSocket = null;

export const socketInit = (isWelcomeMsgEmit = true) => {
	if (!engtSocket) {
		engtSocket = new EngtSocket();
		const launchScreen = ENGT_CHAT.get('config.isLaunchScreenEnabled') || undefined;
		engtSocket.onAskUserId();
		if (!launchScreen || ENGT_CHAT.get('config.bot_mode') === BOT_MODE.STANDALONE) {
			if (ENGT_CHAT.get('triggerButtonConfig')?.isFlowTriggeredFromTriggers) {
				handleTriggersCallbackClicks();
			} else {
				engtSocket.onWelcomeMsg(isWelcomeMsgEmit);
			}
		} else if (ENGT_CHAT.get('triggerButtonConfig')?.isFlowTriggeredFromTriggers && launchScreen) {
			ENGT_CHAT.get('showChatScreen')();
			handleTriggersCallbackClicks(true);
		} else {
			engtSocket.onWelcomeMsg(false, true);
		}
		engtSocket.gotUserId();
		engtSocket.onLocaleChange();
		engtSocket.onChatHistoryMsgs();
		engtSocket.onBotResponse();
		engtSocket.onAttachmentTransId();
		if (isOldUser()) {
			engtSocket.changeChatStatus('chat opened', true);
		}
		engtSocket.onSocketDisconnect();
		engtSocket.onWebsiteClose();
		engtSocket.onSocketError();
		engtSocket.onSocketConnectError();
		if (ENGT_CHAT.get('currentScreen') === SCREEN_TYPE.CHAT) {
			engtSocket.askUserName();
		}
		if (!!ENGT_CHAT.get('config.loadChatHistory')) {
			ENGT_CHAT.get('checkAndfetchMessages')(new Date());
		}
	} else if (ENGT_CHAT.get('triggerButtonConfig')?.isFlowTriggeredFromTriggers) {
		const triggerConfig = ENGT_CHAT.get('triggerButtonConfig');
		if (triggerConfig.triggerStartNewConversation) {
			ENGT_CHAT.get('startNewConversation')();
		} else {
			ENGT_CHAT.get('sendMessage')(triggerConfig.text, {
				message: {
					postback: triggerConfig.postback,
					type: 'postback',
					text: triggerConfig.text,
				},
			});
		}
	}
};

const handleTriggersCallbackClicks = (isLaunchScreenEnabled = false) => {
	const triggerConfig = ENGT_CHAT.get('triggerButtonConfig');
	if (ENGT_CHAT.get('firstTime')) {
		if (triggerConfig.triggerStartNewConversation) {
			ENGT_CHAT.get('startNewConversation')();
		} else {
			engtSocket.onWelcomeMsg(
				true,
				isLaunchScreenEnabled,
				triggerConfig?.flowKey,
				triggerConfig?.attributes,
				triggerConfig?.text,
				triggerConfig?.botMessages
			);
		}
	} else {
		ENGT_CHAT.get('sendMessage')(triggerConfig.text, {
			message: {
				postback: triggerConfig.postback,
				type: 'postback',
				text: triggerConfig.text,
			},
		});
	}
};

export const disconnect = () => {
	engtSocket.disconnect();
};

export const updateAttribute = (attributes) => {
	engtSocket.updateAttribute(attributes);
};

export const emitWelcomeMsg = (msgEmitJson, data) => {
	const keyResponse = eval(data);
	const ipAddressObtained = ENGT_CHAT.get('config.userIpAddress');
	const isIpAddressAvailable = !!ipAddressObtained && typeof ipAddressObtained === 'string';
	ENGT_CHAT.set('config.key', keyResponse);
	msgEmitJson['key'] = keyResponse;

	if (ENGT_CHAT.get('config.enableIpAddress') && ENGT_CHAT.get('config.ipAddressPromise')) {
		const onSuccesfulIpFetch = (ipAddress) => {
			if (readFromLs(LS().IP_ADDRESS) !== ipAddress) {
				msgEmitJson['ip_address'] = ipAddress;
				writeToLs(LS().IP_ADDRESS, ipAddress);
			}
			engtSocket.emitEvent('welcome_msg', msgEmitJson);
		};

		if (isIpAddressAvailable) {
			onSuccesfulIpFetch(ipAddressObtained);
		} else {
			ENGT_CHAT.get('config')
				.ipAddressPromise?.then?.(onSuccesfulIpFetch)
				.catch((err) => {
					LOGGER('error while getting ip address: ', err);
					engtSocket.emitEvent('welcome_msg', msgEmitJson);
				});
		}
	} else {
		engtSocket.emitEvent('welcome_msg', msgEmitJson);
	}
};

export const emitAskUserIdEvent = () => {
	engtSocket.emitAskUserId(
		ENGT_CHAT.get('config.isLaunchScreenEnabled') && ENGT_CHAT.get('config.bot_mode') === BOT_MODE.WIDGET
	);
};

export const emitInitMsgEvent = (flowKey) => {
	if (ENGT_CHAT.get('triggerButtonConfig')?.isFlowTriggeredFromTriggers) {
		const triggerConfig = ENGT_CHAT.get('triggerButtonConfig');
		const launchScreen = ENGT_CHAT.get('config.isLaunchScreenEnabled');
		engtSocket.onWelcomeMsg(
			true,
			launchScreen,
			triggerConfig?.flowKey,
			triggerConfig?.attributes,
			triggerConfig?.text,
			triggerConfig?.botMessages
		);
	} else {
		engtSocket.onWelcomeMsg(true, ENGT_CHAT.get('config.isLaunchScreenEnabled'), flowKey);
	}
};

export const getAttachmentTransactionId = () => {
	engtSocket.getAttachmentTransactionId();
};

export const updateChatEvent = (status) => {
	const text = status ? 'chat opened' : 'chat closed';
	engtSocket.changeChatStatus(text, status);
};

export const setConfigForMsgRecieved = (dataRecieved) => {
	const { message } = dataRecieved;

	if (message?.data && message?.type === MESSAGE_TYPE.AGENT_PARTICIPATION_STATUS) {
		const agentMsg = message.data.PARTICIPATION_MESSAGE;

		if (message.data.PARTICIPATION_STATUS === 'JOINED') {
			writeToLs(LS().LIVECHAT, 'true');
			ENGT_CHAT.get('showUploadBtnForLiveChat')?.();
			ENGT_CHAT.get('showInputBox')?.();
		} else {
			writeToLs(LS().LIVECHAT, 'false');
			ENGT_CHAT.get('hideUploadBtnForLiveChat')?.();

			if (ENGT_CHAT.get('config.showReplyArea') === false) {
				ENGT_CHAT.get('hideInputBox')();
			}
		}

		ENGT_CHAT.get('reRenderHeaderOptions')();
	}
};

export const handleAuthenticationOfIdentityNode = (data) => {
	const { login_success } = data.message.data;
	if (readFromLs(LS().PREV_MESSAGES)) {
		const oldMessages = JSON.parse(readFromLs(LS().PREV_MESSAGES));
		if (login_success) {
			for (let i = 0; i < oldMessages.length; i++) {
				if (oldMessages[i].message_id === ENGT_CHAT.get('lastIdentityNode')) {
					oldMessages[i].validated = true;
				}
			}
		}
		writeToLs(LS().PREV_MESSAGES, JSON.stringify(oldMessages));
	}
	ENGT_CHAT.get('validateFormNode')(data.message.data);
	if (login_success && data.message.data['user_id'] !== data['user_id']) {
		writeToLs(LS().NEW_SESSION, data.message.data['user_id']);
		ENGT_CHAT.set('status.sessionKey', readFromLs(LS().NEW_SESSION));
		disconnect();
	}
};

export const botResponse = (data) => {
	const { ack } = data;

	LOGGER('bot response -->', data);
	if (!data.sender) {
		data.sender = MESSAGE_SENDER.BOT;
	}
	storeBotResponseInLs(data);
	ENGT_CHAT.get('showTypingIndicator')(data, 'engt-typing-indicator');

	if (ack != null) {
		engtSocket.emitEvent('msg_received', {
			user_id: data['user_id'],
			bot_ref: data['bot_ref'],
			bot_key: ENGT_CHAT.get('config.bot_key'),
			ack,
		});
		if (data['message_id'] === ENGT_CHAT.get('lastMsgId') && data?.source_node_type !== 'RCV_INP') {
			return;
		}
		const ackRecieved = parseInt(ack.substr(0, ack.indexOf('__')));
		ENGT_CHAT.set('lastMsgId', data['message_id']);
		ENGT_CHAT.set('ack', ackRecieved);
	}

	if (data.message.type === MESSAGE_TYPE.IDENTITY && data.message.data.hasOwnProperty('login_success')) {
		handleAuthenticationOfIdentityNode(data);
	}
	setConfigForMsgRecieved(data);

	if (data.message && data.message.type) {
		if (ENGT_CHAT.get('config.isConversationalIvrEnabled') && data.message.text) {
			playVoiceFromAzure(data.message.text);
		} else {
			readOutMessage(data);
		}
		appendToChat(data, { type: data.message.type });
	}
	const messageToBeDisplayed = data['messageToBeDisplayed'];
	let isFlowKeyExist = false;
	if (
		data.flow_key &&
		data.bot_ref &&
		data.flow_key !== `greetings_${data.bot_ref}` &&
		data.flow_key !== `default_fallback_msg_${data.bot_ref}`
	) {
		isFlowKeyExist = true;
	}
	if (messageToBeDisplayed && data.message.type == 'text' && !isFlowKeyExist) {
		appendToChat(
			{
				...data,
				message: {
					sender: 'user',
					text: messageToBeDisplayed,
				},
				sender: 'user',
				type: 'text',
			},
			{
				storeMsgInLs: true,
				isOldMessage: false,
			}
		);
	}
};

export const fetchUserMessages = (lastMessageTime) => {
	if (!readFromLs('chatMessageTimestamp')) {
		writeToLs('chatMessageTimestamp', new Date());
	}
	const msgTime = lastMessageTime ? lastMessageTime : new Date(readFromLs('chatMessageTimestamp'));

	const data = {
		userId: ENGT_CHAT.get('status.sessionKey'),
		botKey: ENGT_CHAT.get('config.bot_key'),
		conversationId: ENGT_CHAT.get('status.sessionKey'),
		pageSize: 50,
		to: msgTime.getTime() - 1,
	};
	engtSocket.emitEvent('request_chat_history', data, (response) => {
		ENGT_CHAT.set('config.temporaryRoomId', response);
	});
};

export const emitMessage = (socketName, data, cbFn) => {
	engtSocket.emitEvent(socketName, data, cbFn);
};

export const emitForUserCreationInLaunchScreen = () => {
	engtSocket.changeChatStatus('chat opened', true);
	engtSocket.askUserName();
};

export const isOldUser = () =>
	ENGT_CHAT.get('currentScreen') === SCREEN_TYPE.CHAT ||
	(ENGT_CHAT.get('currentScreen') === SCREEN_TYPE.LAUNCH && readFromLs(LS().PREV_MESSAGES));
